import styled from 'styled-components';
import { ImageUtils } from '../../../../utils/ImageUtils';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { OFFLINE_INFO_CONSTANTS } from '../../../../constants/offlineInfo';

export const OfflineInfoMobile = () => {
  const { getText } = useTextVariant(OFFLINE_INFO_CONSTANTS, true);

  return (
    <>
      <Item>
        <FullTextContainer>
          <FullText>{getText('fullText')}</FullText>
        </FullTextContainer>
        <TitleContainer>
          <img src={ImageUtils.ArrowRightIcon} style={{ width: 7, marginRight: 4 }} />
          <Title>{getText('titleHolder')}</Title>
        </TitleContainer>
        <Content>
          <LocationTitle>
            <span>{getText('venue')}</span>
          </LocationTitle>
          <LocationDesc>{getText('venueAddress')}</LocationDesc>
        </Content>

        <Content>
          <LocationTitle>{getText('eventDate')}</LocationTitle>
          <LocationDesc>{getText('entryTime')}</LocationDesc>
        </Content>

        <WaringContainer>
          <WaringText>{getText('warningTicket')}</WaringText>
        </WaringContainer>

        <DetailContainer>
          <DetailText>{getText('detailInfo')}</DetailText>
        </DetailContainer>
      </Item>
    </>
  );
};

const FullTextContainer = styled.div`
  margin-bottom: 4px;
`;

const FullText = styled.h3`
  color: #3fb5ff;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -1.04px;
`;

const DetailContainer = styled.div`
  margin-top: 8px;
  padding-bottom: 30px;
  padding-top: 8px;
  border-top: 1px solid rgba(112, 112, 112, 0.5);
`;

const DetailText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  text-align: left;

  span {
    color: #fae100;
    font-weight: 400;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: 6.5%;
    text-underline-offset: 25%;
    text-underline-position: from-font;
    cursor: pointer;
  }
`;

const LocationTitle = styled.h4`
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;

  span {
    border-radius: 30px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    padding: 2px 20px;
    display: inline-block;
  }
`;

const LocationDesc = styled.h3`
  color: rgba(255, 255, 255, 0.6);
  text-align: left;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin-top: 4px;
  margin-bottom: 4px;

  display: flex;
  align-items: center;
  img {
    margin-right: 4px;
  }
  margin-bottom: 20px;
`;

const Item = styled.div`
  margin-bottom: 50px;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

const Title = styled.h3`
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 0;
`;

const Content = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 16px;
`;

const WaringContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 20px;
  margin-top: 6px;
`;

const WaringText = styled.li`
  color: #8e8e8e;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.84px;
  position: relative;

  &:after {
    content: '';
    width: 5px;
    height: 5px;
    background: #8e8e8e;
    border-radius: 50%;
    position: absolute;
    left: -15px;
    top: 50%;
    transform: translateY(-50%);
  }

  strong {
    color: white;
    text-decoration: underline;
  }
`;
